import { z } from 'zod';

/**
 * The address the club's e-mails (today: invitations) are sent from, shown with the club name as the
 * sender. The mail server must be allowed to send for this address (SPF/DKIM of its domain), or
 * recipients' providers may reject or junk the message. Null stops invitation e-mails.
 */
export const updateMailSettingsRequestSchema = z.strictObject({
  senderEmail: z
    .string()
    .trim()
    .transform((address) => (address === '' ? null : address.toLowerCase()))
    .pipe(z.email().max(254).nullable())
    .nullable(),
});
export type UpdateMailSettingsRequest = z.infer<typeof updateMailSettingsRequestSchema>;

export interface MailSettingsView {
  senderEmail: string | null;
  /** False when the server has no mail server configured; e-mails are then not sent at all. */
  deliveryAvailable: boolean;
  /** Organization row version; send it in `If-Match` when saving. */
  version: number;
}
